export const GRAPHQL_PATH = '/soa/graphql/';
export const QUERY_STRING_HEADER = 'x-dibs-query-params';
